import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent {
  public feautureCustomerSupportURL: string;
  public labels: SiteContentInterface;
  constructor(
      public navCtrl: NavController,
      public appLinks:AppLinksService,
      public config: ConfigService,
      private siteContentService: SiteContentService
  ) {
    this.labels = new SiteContentModel();
  }

  ngOnInit() {
      this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL || '';
  }

  ngAfterViewInit(){
    this.siteContentService.loadConfig('delete_account')
    .then((response: SiteContentInterface) => {
      this.labels = response
    })
}

  goToFeautureCustomerSupportURL() {
      this.appLinks.openExternalPage(this.feautureCustomerSupportURL);
      return false;
  }

}
